import React from 'react';
import styles from './index.less';
import placehodelImg from './imgs/placehodle.png';
import { TLang } from '@/utils/lang';
import { unionFlag } from '@/utils';
interface ISuspend{
  msg:string,
  img?:any,
  btn?:any,
  mHieght?:any
}
function SuspendBusiness(props:ISuspend):JSX.Element{
  return (
    <div className={styles.hotEmptyContainer} style={{height:props.mHieght}}>
      <img src={props.img?props.img:placehodelImg} alt=""/>
      <span>{props.msg}</span>
      {
        props.btn?
          <div className={styles.btnContainer} onClick={() => {props.btn.onClick();}}>{props.btn.text}</div>
        :null
      }
      <p className={styles.serve}>{TLang('如有疑问请联系', 'home', false, false, null)}：{unionFlag() ? '400-618-2999' : '400-003-1010'}</p>
    </div>
  );
}
export default SuspendBusiness;
